export var PaymentTermContexts;
(function (PaymentTermContexts) {
    PaymentTermContexts["OfTheFollowingMonth"] = "of the following month";
    PaymentTermContexts["DaysAfterTheInvoiceDate"] = "day(s) after the invoice date";
    PaymentTermContexts["DaysAfterTheEndOfTheInvoiceMonth"] = "day(s) after the end of the invoice month";
    PaymentTermContexts["OfTheCurrentMonth"] = "of the current month";
})(PaymentTermContexts || (PaymentTermContexts = {}));
